/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { createDataActionHook, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { SalesOrder } from '@msdyn365-commerce/retail-proxy';
import { TelemetryEvent } from '@msdyn365-commerce/telemetry-internal';
import { getProductTransactionInfoFromSalesOrder } from './telemetry.action.helper';

const beforePurchase = async (inputs: IActionInput | IActionInput[]) => {
    // placeholder
};

const afterPurchase = async (
    _inputs: IActionInput | IActionInput[],
    salesOrder: SalesOrder | SalesOrder[],
    actionContext: IActionContext
) => {
    const _msdyn365 = window && (<any>window)._msdyn365;

    if (_msdyn365 && _msdyn365.telemetry) {
        // store the purchased product information so that we can avoid "code triggered" remove from cart telemetry event.
        actionContext.requestContext.telemetryData[TelemetryEvent.Purchase] = getProductTransactionInfoFromSalesOrder(
            salesOrder,
            actionContext.requestContext.telemetryData
        );

        _msdyn365.telemetry.logEvent(TelemetryEvent.Purchase, actionContext.requestContext.telemetryData[TelemetryEvent.Purchase]);
    }
};

createDataActionHook({
    actionId: '@msdyn365-commerce/retail-proxy/Carts/Checkout',
    postReaderHook: afterPurchase,
    preReaderHook: beforePurchase
});
